import { render } from "./SFormElementSelect.vue?vue&type=template&id=647f9152&scoped=true&ts=true"
import script from "./SFormElementSelect.vue?vue&type=script&lang=ts"
export * from "./SFormElementSelect.vue?vue&type=script&lang=ts"

import "./SFormElementSelect.vue?vue&type=style&index=0&id=647f9152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647f9152"]])

export default __exports__